module.exports = __webpack_public_path__ + "static/media/landing-page.804b7da5.svg";